import Assets from 'imports/assets.import';
import { STRINGS } from 'constants/strings.constant';
import './zoom_pill.component.scss';

const MIN_ZOOM = 10;
const MAX_ZOOM = 200;
const ZOOM_STEP = 10;

interface ZoomPillProps {
  value: number;
  onChange: (value: number) => void;
  onReset: () => void;
}

const ZoomPill = ({ value, onChange, onReset }: ZoomPillProps): JSX.Element => {
  const strings = STRINGS.zoomPill;
  return (
    <div className="zoom_pill">
      <button type="button" className="zoom_pill_button" aria-label={strings.zoomOut} onClick={() => onChange(Math.max(MIN_ZOOM, value - ZOOM_STEP))}>
        <img src={Assets.zoom_out} alt="" />
      </button>
      <button type="button" className="zoom_pill_percentage" aria-label={strings.resetZoom} onClick={onReset}>
        {value}%
      </button>
      <button type="button" className="zoom_pill_button" aria-label={strings.zoomIn} onClick={() => onChange(Math.min(MAX_ZOOM, value + ZOOM_STEP))}>
        <img src={Assets.zoom_in} alt="" />
      </button>
    </div>
  );
};

export default ZoomPill;
